import Repository, { getDefaultCRUDMethods } from "./Repository";

const resource = "/Utilisateur";

export default {
  // use default CRUD
  findOneById: getDefaultCRUDMethods({ resource }).findOneById,
  put: getDefaultCRUDMethods({ resource }).put,
  deleteOneById: getDefaultCRUDMethods({ resource }).deleteOneById,

  //Use custom search
  get({
    page = 1,
    pageSize = 30,
    sortField = "nom",
    sortType = "asc",
    searchQuery = "",
    active = null,
    locked = null,
    cancelToken = null
  }) {
    return Repository.post(
      `${resource}/Search`,
      {
        pageNumber: page,
        pageSize,
        sortField,
        sortType
      },
      {
        cancelToken,
        params: {
          criteria: searchQuery !== null ? searchQuery : "",
          actif: active,
          locked: locked
        }
      }
    ).then(res => {
      if (res.data && res.data.content && res.data.content.list) {
        res.data.content.list = res.data.content.list.filter(
          (thing, index, self) =>
            index === self.findIndex(t => t.id === thing.id)
        );
      }
      return res;
    });
  },

  isLoginAvailable({ login = "", currentUserId = null, cancelToken = null }) {
    return Repository.get(`${resource}/IsLoginAvailable`, {
      params: {
        utilisateurLogin: login,
        utilisateurId: currentUserId
      },
      cancelToken
    });
  },
  getByLogin({ login = "" }) {
    return Repository.get(`${resource}/GetByLogin/${login}/`);
  },
  getUserAcces({ userId = null, companyIds = [] }) {
    return Repository.put(`${resource}/GetAcces`, companyIds, {
      params: { utilisateurId: userId }
    });
  },
  disableUsers({ users = [] }) {
    return Repository.put(
      `${resource}/Disable`,
      users.map(user => user.id)
    );
  }
};
